<template>
  <div class="course-container">
    <headerPage></headerPage>
    <div class="course-tou">
      <!-- 根据选中的选项卡显示章节列表 -->
      <div v-if="activeTab === 'course-chapters'">
        <div class="page-header">
          <div class="page-header2">
            <!-- 返回按钮 -->
            <el-page-header @back="goBack"  class="return-button"></el-page-header>
            <h2 class="page-title">课程目录</h2>
          </div>
          <div class="divider"></div>
        </div>
        <div class="chapter-list">
          <el-row :gutter="10" class="chapter-row">
            <el-col :xs="24" v-for="(chapter, index) in chapterList" :key="index" class="chapter-col">
              <div class="chapter-card" shadow="hover">
                <div class="chapter-content">
                  <!-- 修改布局，让标题和操作区域在一行且靠右 -->
                  <div class="chapter-title">
                    <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                      <path d="M132.4 244.7h760.7c20.1 0 36.5-16.3 36.5-36.5s-16.3-36.5-36.5-36.5H132.4c-20.1 0-36.5 16.3-36.5 36.5s16.4 36.5 36.5 36.5z m760.7 133.9H397.5c-20.1 0-36.5 16.3-36.5 36.5 0 20.1 16.3 36.5 36.5 36.5h495.6c20.1 0 36.5-16.3 36.5-36.5 0-20.1-16.3-36.5-36.5-36.5z m0 210.1H397.5c-20.1 0-36.5 16.3-36.5 36.5s16.3 36.5 36.5 36.5h495.6c20.1 0 36.5-16.3 36.5-36.5s-16.3-36.5-36.5-36.5z m0 203H132.4c-20.1 0-36.5 16.3-36.5 36.5s16.3 36.5 36.5 36.5h760.7c20.1 0 36.5-16.3 36.5-36.5s-16.3-36.5-36.5-36.5zM129 660.8l172.3-128.6c9.8-7.3 9.7-20.8-0.1-28L128.9 377.5c-13.3-9.8-33.4-1.3-33.4 14v255.3c-0.1 15.5 20.2 24 33.5 14z"></path>
                    </svg>
                    {{ chapter.chapterTitle }}
                  </div>
                  <div class="chapter-actions">
                    <span class="chapter-status">{{ chapter.progress }}% 完成度</span>
                    <el-button type="primary" size="small" class="start-btn" @click="startLearn(chapter.id)">
                      开始学习
                    </el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <bottomPage></bottomPage>
  </div>
</template>

<script>
import headerPage from "@/components/header/header";
import bottomPage from "@/components/bottom/bottom";
import * as CourseApi from "@/api/course";

export default {
  components: {
    headerPage,
    bottomPage,
  },
  data() {
    return {
      // 当前激活的选项卡
      activeTab: 'course-chapters',  // 默认选中课程章节
      // 课程基本信息
      courseInfo: {
        classId: "",
        imageUrl: "",
        rating: 0,
        reviews: 0,
      },
      // 章节列表
      chapterList: [],
      // 模拟考试列表
      mockExamList: [],
    };
  },
  created() {
    const {courseId,className, classImg,classId} = this.$route.params;
    this.courseInfo.courseId = courseId;
    this.courseInfo.classId = classId;
    this.courseInfo.title = className; // 直接使用传递过来的值
    this.courseInfo.imageUrl = classImg; // 直接使用传递过来的值
    this.fetchChapters();
  },
  methods: {

    async fetchChapters() {
      try {
        const response = await CourseApi.getCourseChapter(this.$route.params.courseId, this.$route.params.classId);
        if (response.code === 0 && response.data) {
          this.chapterList = response.data.map(chapter => ({
            id: chapter.id,
            chapterTitle: chapter.chapterTitle,
            isComplete: chapter.isComplete,
            progress: this.calculateProgress(chapter.completePercent),
          }));
        }
      } catch (error) {
        console.error("获取章节数据失败：", error);
      }
    },
    getRandomNumberInRange(min, max, decimalPlaces) {
      const random = Math.random() * (max - min) + min;
      return parseFloat(random.toFixed(decimalPlaces));
    },
    calculateProgress(completeTime) {
      return completeTime > 0 ? Math.min(100, completeTime / 100) : 0;
    },
    // 设置激活的选项卡
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    startLearn(chapterId) {
      this.$router.push({
        name: "courseDetail",
        params: {
          classId: this.$route.params.classId,
          courseId: this.$route.params.courseId,
          chapterId: chapterId,
        },
      });
    },
    // 返回上一页
    goBack() {
      this.$router.push('/myClassInfo');
    },
  },
};
</script>

<style scoped>
/* 页面容器样式 */
.course-container {
  background-color: #f5f5f5;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.course-tou {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 200px;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #ffffff;
}

/* 页头区域样式 */
.page-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.page-header2 {
  display: flex;
  align-items: center;
}

.course-row {
  width: 100%;
}

/* 页标题样式 - 左对齐 */
.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  text-align: left;
}

/* 分割线样式 - 灰色铺满 */
.divider {
  width: 100%;
  height: 2px;
  background-color: #dcdfe6;
}


/* 章节列表 */
.chapter-list {
  width: 100%;
  height: 550px; /* 固定高度，根据需要调整 */
  overflow-y: auto; /* 允许垂直滚动 */
  overflow-x: hidden; /* 禁止水平滚动 */
  margin: 20px auto;
}

.chapter-row {
  width: 100%;
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
}

/* 章节卡片 */
.chapter-col {
  margin-bottom: 10px;
  width: 100%;
}

/* 卡片样式 */
.chapter-card {
  width: 100%;
  height: 40px; /* 固定高度，根据需要调整 */
  border-radius: 5px;
  overflow: hidden;
  transition: box-shadow 0.3s;
  cursor: pointer;
  display: flex; /* 使用 flex 布局 */
  justify-content: space-between; /* 章节标题和操作区域分别靠左和靠右 */
  align-items: center; /* 垂直居中 */
  background-color: #f5f5f5;
  padding: 0 10px; /* 添加内边距 */
}

.chapter-card:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 章节内容 */
.chapter-content {
  width: 100%;
  display: flex;
  justify-content: space-between; /* 让子元素靠右对齐 */
  align-items: center; /* 垂直居中对齐 */
  gap: 20px; /* 设置标题和操作区域之间的间距 */
}

/* 章节标题 */
.chapter-title {
  display: flex;
  align-items: center; /* 图标和标题垂直居中对齐 */
  gap: 10px; /* 设置图标与标题之间的间距 */
  /* 移除 margin-right: auto */
}

/* 章节操作区域 */
.chapter-actions {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
}

/* 题目完成状态 */
.chapter-status {
  font-size: 14px;
  color: #666;
  margin-right: 15px;
}
/* 开始答题按钮 */
.start-btn {
  margin-left: 10px; /* 添加左边距 */
}
</style>
